import { render, staticRenderFns } from "./MemoryCard.vue?vue&type=template&id=5c130182&scoped=true&"
import script from "./MemoryCard.vue?vue&type=script&lang=js&"
export * from "./MemoryCard.vue?vue&type=script&lang=js&"
import style0 from "./MemoryCard.vue?vue&type=style&index=0&id=5c130182&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c130182",
  null
  
)

export default component.exports